export enum RemoTheme {
  dark = "DARK",
  light = "LIGHT",
}
